{
  "CONTACTS_FILTER": {
    "TITLE": "过滤联系人",
    "SUBTITLE": "添加过滤器并点击“提交”以过滤联系人。",
    "EDIT_CUSTOM_SEGMENT": "编辑分段",
    "CUSTOM_VIEWS_SUBTITLE": "添加或删除过滤器并更新您的分段。",
    "ADD_NEW_FILTER": "添加过滤器",
    "CLEAR_ALL_FILTERS": "清除所有过滤器",
    "FILTER_DELETE_ERROR": "您至少需要一个过滤器来保存",
    "SUBMIT_BUTTON_LABEL": "提交",
    "UPDATE_BUTTON_LABEL": "更新分段",
    "CANCEL_BUTTON_LABEL": "取消",
    "CLEAR_BUTTON_LABEL": "清除过滤器",
    "EMPTY_VALUE_ERROR": "必须填写值",
    "SEGMENT_LABEL": "分段名称",
    "SEGMENT_QUERY_LABEL": "分段查询",
    "TOOLTIP_LABEL": "过滤联系人",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "和",
      "OR": "或"
    },
    "OPERATOR_LABELS": {
      "equal_to": "等于",
      "not_equal_to": "不等于",
      "contains": "包含",
      "does_not_contain": "不包含",
      "is_present": "存在",
      "is_not_present": "不存在",
      "is_greater_than": "大于",
      "is_lesser_than": "小于",
      "days_before": "是 x 天前"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "必须填写值"
    },
    "ATTRIBUTES": {
      "NAME": "姓名：",
      "EMAIL": "电子邮件",
      "PHONE_NUMBER": "电话号码",
      "IDENTIFIER": "标识符",
      "CITY": "城市",
      "COUNTRY": "国家",
      "CUSTOM_ATTRIBUTE_LIST": "列表",
      "CUSTOM_ATTRIBUTE_TEXT": "文本",
      "CUSTOM_ATTRIBUTE_NUMBER": "号码",
      "CUSTOM_ATTRIBUTE_LINK": "链接",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "复选框",
      "CREATED_AT": "创建于",
      "LAST_ACTIVITY": "最后一次活动",
      "REFERER_LINK": "引用链接",
      "BLOCKED": "已阻止",
      "LABELS": "标签"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "标准过滤器",
      "ADDITIONAL_FILTERS": "附加过滤器",
      "CUSTOM_ATTRIBUTES": "自定义属性"
    }
  }
}
